<template>
  <v-container>
    <!-- Výběr oblasti -->
     <v-row class="mb-4">
      <v-col cols="7" md="3">
        <v-select
          v-model="selectedRegion"
          :items="regions"
          label="Vyber oblast"
          item-title="title"
          item-value="value"
          density="comfortable"
          hide-details="true"
        />
      </v-col>

      <v-col cols="5" md="2">
        <SelectYear v-model="selectedYear" />
      </v-col>

      <v-spacer class="d-none d-sm-flex" />
      <v-col cols="12" sm="auto" class="d-none d-sm-flex align-center justify-end">
        <h3 class="text-body-1 mb-0">{{ $t('ranking.drop_count', { count: ranking.drop_count }) }}</h3>
      </v-col>
    </v-row>
    <RankingTable 
    :loading="loading" 
    :ranking="ranking" 
    @refreshRanking="() => fetchRanking(selectedRegion, selectedYear)"
    />

    <!-- Zobrazení zprávy, pokud nejsou závody -->
    <v-alert v-if="!ranking.races.length && !ranking.categories.length && !loading" type="info" class="mt-4">
      Nejsou vypsané žádné závody do tohoto žebříčku.
    </v-alert>

  </v-container>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiClient from '/api.js';
import RankingTable from '@/components/shared/RankingTable.vue';
import SelectYear from '@/components/shared/SelectYear.vue';

const route = useRoute();
const router = useRouter();
const loading = ref(true);
const ranking = ref({ races: [], categories: [], drop_count: 0 }); // **Zajištění, že nebude undefined**


// **Seznam regionů pro výběr**
const regions = [
  { value: 'A', title: 'Praha' },
  { value: 'B', title: 'Střední Čechy' },
  { value: 'C', title: 'Jižní Čechy' },
  { value: 'D', title: 'Západní Čechy' },
  { value: 'E', title: 'Severní Čechy' },
  { value: 'F', title: 'Východní Čechy' },
  { value: 'G', title: 'Jižní Morava' },
  { value: 'H', title: 'Severní Morava a Slezsko' }
];
const regionSet = new Set(regions.map(r => r.value));

const thisYear = new Date().getFullYear();
const parseYear   = v => (Number.isFinite(+v) ? +v : thisYear);
const parseRegion = v => (regionSet.has(String(v).toUpperCase()) ? String(v).toUpperCase() : 'G');


const selectedRegion = ref(parseRegion(route.params.region));
const selectedYear   = ref(parseYear(route.params.year));


// **Načítání dat z API**
const fetchRanking = async (region, year) => {
  loading.value = true;
  ranking.value = { races: [], categories: [], drop_count: 0 }; // **Reset před načtením nových dat**
  
  try {
    const response = await apiClient.get(`/ranking/${region}/${year}/`);
    ranking.value = response.data || { races: [], categories: [], drop_count: 0 }; // **Zajistí, že nevrátíme undefined**
  } catch (error) {
    if (error?.response?.status === 404) ranking.value = { races: [], categories: [], drop_count: 0 };
    else console.error(error);
  } finally {
    loading.value = false;
  }
}


// Aktualizace dat na základě změn v URL

// ROUT je zdroj pravdy → načti (i poprvé)
watch(
  () => [route.params.region, route.params.year],
  () => {
    const r = parseRegion(route.params.region);
    const y = parseYear(route.params.year);
    if (r !== selectedRegion.value) selectedRegion.value = r;
    if (y !== selectedYear.value)   selectedYear.value   = y;
    fetchRanking(r, y);
  },
  { immediate: true }
);

// UI změna → přepiš URL (spustí watcher výše)
watch([selectedRegion, selectedYear], ([r, y]) => {
  const path = `/ranking/${r}/${y}`; // bez trailing slash
  if (route.path !== path) router.replace({ path });
});


</script>